import { reject, values, sortBy, includes } from "lodash";
import store from "../store";
export function getNoteCount() {
    var notes = store.getState().notes.notes;
    return reject(values(notes), {
        __hidden: true
    }).length;
}
export function getNotesChronologically(notes) {
    return sortBy(reject(values(notes), {
        __hidden: true
    }), "updated_at");
}
export function getPrintNotesByChart(id, printNotes) {
    return reject(printNotes, function(n) {
        return !includes(n.node_ids, id);
    });
}
